import { emptyFilterGroup } from 'pe-core-frontend';
export const isEveryoneCriteria = (criteria) => {
    if (!criteria)
        return true;
    const { groups, conditions } = criteria;
    const groupsIsEmpty = Array.isArray(groups) && groups.length === 0;
    const conditionsIsEveryone = conditions.length === 0 ||
        (Array.isArray(conditions) &&
            conditions.length === 1 &&
            conditions[0] &&
            conditions[0].op === '' &&
            Array.isArray(conditions[0].values) &&
            conditions[0].values.length === 0 &&
            conditions[0].fieldCode === '' &&
            conditions[0].entityType === 'employee');
    return groupsIsEmpty && conditionsIsEveryone;
};
/**
 * Checks if a filter condition is complete and valid
 * A condition is complete if it has (fieldCode OR entityType) AND operator AND (values OR dateOperator='now')
 *
 * @param condition - The filter condition to validate
 */
export const isConditionComplete = (condition) => {
    // Check if fieldCode OR entityType is filled
    const hasFieldCode = !!(condition.fieldCode && condition.fieldCode !== '');
    const hasEntityType = !!(condition.entityType && condition.entityType !== '');
    const hasFieldOrEntity = hasFieldCode || hasEntityType;
    // Check if operator is filled (not empty string)
    const hasOperator = !!(condition.op && condition.op !== '');
    // Check if values are filled (array with at least one item) OR if using "now" date operator
    // When dateOperator is "now", the values array is intentionally empty
    const hasValues = (Array.isArray(condition.values) && condition.values.length > 0) ||
        condition.dateOperator === 'now';
    // For population/entity filters, we need entityType + operator + values
    // For field filters, we need fieldCode + operator + values
    return hasFieldOrEntity && hasOperator && hasValues;
};
/**
 * Checks if a filter group has at least one valid condition
 */
export const hasValidConditions = (criteria) => {
    if (!criteria)
        return false;
    // Check if there are any valid/complete conditions
    const validConditions = criteria.conditions?.filter(c => isConditionComplete(c)) || [];
    if (validConditions.length > 0)
        return true;
    // Recursively check nested groups for valid conditions
    return criteria.groups?.some(g => hasValidConditions(g)) || false;
};
/**
 * Checks if a filter group has any incomplete conditions
 */
export const hasIncompleteConditions = (criteria) => {
    if (!criteria)
        return false;
    // Check if any conditions are incomplete
    const hasIncomplete = criteria.conditions?.some(c => !isConditionComplete(c)) || false;
    if (hasIncomplete)
        return true;
    // Recursively check nested groups
    return criteria.groups?.some(g => hasIncompleteConditions(g)) || false;
};
/**
 * Removes incomplete conditions from a filter group
 * Returns a cleaned filter group with only valid conditions, or "everyone" format if empty
 */
export const cleanCriteria = (criteria) => {
    // If no criteria provided, return "everyone" format
    if (!criteria) {
        return emptyFilterGroup;
    }
    // Remove any incomplete conditions using the isConditionComplete helper
    const cleanedConditions = criteria.conditions?.filter(c => isConditionComplete(c)) || [];
    // Recursively clean nested groups
    const cleanedGroups = criteria.groups?.map(g => cleanCriteria(g)) || [];
    // Return "everyone" format if the group would be empty after cleaning
    if (cleanedConditions.length === 0 && cleanedGroups.length === 0) {
        return emptyFilterGroup;
    }
    return {
        ...criteria,
        conditions: cleanedConditions,
        groups: cleanedGroups,
    };
};
